// eslint-disable-next-line no-unused-vars
import React from 'react';
import JobList from './components/JobList';
import JobSearchAssistance from './components/JobSearchAssistance';
import TeamHeroSection from './components/TeamHeroSection';

/**
 * Represents the view for Team page for Life.Church Careers.
 *
 * @param {object} props - The component props object.
 * @param {Array<Job>} props.jobs - Array of job data objects.
 * @param {Team} props.team - The team data object.
 *
 * @returns {React.ReactElement} The Team component.
 */
export default function Team({ jobs, team }) {
  return (
    <div className="team">
      <TeamHeroSection team={team} />
      <p className="team-description">{team.description}</p>
      <JobList jobs={jobs} showFallbackMessage={true} />
      {jobs?.length > 0 ? (
        <JobSearchAssistance messageToShow="available" />
      ) : null}
    </div>
  );
}
